import { List, Map } from 'immutable';

import * as constants from './../constants';
import {
  AppStorageRecord,
} from './../records';

const initialState = Map({
  apps: List(),
  loading: false,
  itemsPerPage: 100,
  currentPage: 1,
  moreItemsAvailable: false,
  nextPageUrl: null,
  prevPageUrl: null,
});

const appStorageVersionsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case constants.APP_STORAGE_FETCH_APPS.REQUEST:
      return state.set('loading', true);
    case constants.APP_STORAGE_DELETE_APP_VERSION.REQUEST: {
      const { id } = payload;
      const updatedApps = state.get('apps').filter((app) => app.id !== id);
      return state.withMutations((mutable) => {
        mutable
          .set('apps', updatedApps)
          .set('loading', true);
      });
    }
    case constants.APP_STORAGE_FETCH_APPS.SUCCESS: {
      const { items, links } = payload;

      const appStorageItems = List(
        items.map((app) => new AppStorageRecord(app)),
      );

      return state.withMutations((mutable) => {
        mutable
          .set('apps', appStorageItems)
          .set('nextPageUrl', links.next)
          .set('prevPageUrl', links.prev)
          .set('moreItemsAvailable', !!links.next)
          .set('loading', false);
      });
    }
    case constants.APP_STORAGE_FETCH_APPS.FAILURE:
    case constants.APP_STORAGE_DELETE_APP_VERSION.SUCCESS:
    case constants.APP_STORAGE_DELETE_APP_VERSION.FAILURE:
      return state.set('loading', false);

    case constants.APP_STORAGE_RESET_APP_VERSIONS:
      return state.withMutations((mutable) => {
        mutable
          .set('apps', initialState.get('apps'))
          .set('nextPageUrl', initialState.get('nextPageUrl'))
          .set('prevPageUrl', initialState.get('prevPageUrl'))
          .set('moreItemsAvailable', initialState.get('moreItemsAvailable'));
      });

    default:
      return state;
  }
};

export default appStorageVersionsReducer;
export { initialState };
